import { HistoryRecord } from '../historyRecord.data';
import { Address } from './address.data';
import { EmergencyContact } from './contact.data';
import { ResidentCode } from './residentCode.data';

export interface PersonContactData {
  id: string;
  estateId: string;
  name: string;
  lastName: string | null;
  phone: string[] | null;
  email: string[] | null;
  userId: string | null;
}

export interface ResidentData extends PersonContactData {
  /** @deprecated unused? */
  apartmentId?: string | null;
  // TODO: remove '?' after reckonings
  /** @deprecated - for new features use residentCodes */
  ownerCode?: string | null;
  residentCodes?: ResidentCode;
  address?: Address | null;
  emergencyContact?: EmergencyContact | null;
  birthDate?: number | null;
  PESEL?: string | null;
  documentNo?: string | null;
  nationality?: string | null;
  lastUpdate: number | null;
  type: LandlordType;
  NIP: string | null;
  REGON: string | null;
  creatorUserId: string | null;
}

export enum LandlordType {
  COMPANY = 'COMPANY',
  PERSON = 'PERSON'
}

export enum ResidentType {
  LANDLORD = 'landlord',
  TENANT = 'tenant',
  UNASSIGNED = 'unassigned'
}

export interface ResidentHistoryRecord extends HistoryRecord<string> {
  residentId: string;
}
